// todo: rename component file name to AddRecordModalV2.js later
/* eslint-disable */
import React, { useContext, useState, useEffect, useRef } from 'react';
import { render } from 'react-dom';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import InputMask from 'react-input-mask';
import CmsContext from 'context/CmsContext';
import Select from 'react-select';
import { reactSelectCustomStyleCms, numberWithCommas } from 'helper';
import ConfirmAlert from "modules/common/components/ConfirmAlert";
import moment from 'moment';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import useFormValidator from 'useFormValidator';
import NumberFormat from 'react-number-format';
import * as actions from '../actions';
import * as c from '../constant';

import { InputTemplate } from "../../../common/components/inputComponents";
import AddressGroupComponent from "../../../common/address/AddressGroupComponent";
import UpdateBusinessActivity from "./UpdateBusinessActivity";

import deleteIcon from "../../../../assets/img/icn-delete.svg";
import updateIcon from "../../../../assets/img/icn-edit.svg";

const usePreviousValue = value => {
  const ref = useRef()
  useEffect(() => {
    ref.current = value
  }, [value])
  return ref.current
}

const AddRecordModalV2 = ({
  // createRecord,
  // getList,
  createRecordManualImport,
  getListManualImport,
  history,
  creating,
  type,
  updateRecordManualImport,
  // updateRecord,
  dataInfo,
  dataInclude,
  id,
}) => {
  const cmsContext = useContext(CmsContext);
  const CMS_COMPONENTS = cmsContext.findByType('COMPONENTS');
  const CMS_MASKINGS = cmsContext.findByType('MASKINGS');

  const [formData, setFormData] = useState({
    ...c.INITIAL_FORMDATA,
    region_code: _.get(CMS_COMPONENTS, "SMART_CITY_SET_SPECIFIC_REGION_FOR_ADDRESS_BILLING") || "",
    province_code: _.get(CMS_COMPONENTS, "SMART_CITY_SET_SPECIFIC_PROVINCE_FOR_ADDRESS_BILLING") || "",
  });

  const [initialActivityFormData, setInitialActivityFormData] = useState(c.INITIAL_ACTIVITY_FORM);

  const [initialFeesFormData, setInitialFeesFormData] = useState(c.INITIAL_FEES_FORM);

  const currentYear = new Date().getFullYear();

  const [isFocus, setFocus] = useState(false)
  const [toggleInitialActivityUpdate, setToggleInitialActivityUpdate] = useState(false)
  const [activityUpdateInfo, setActivityUpdateInfo] = useState({})
  // const [amountPerQuarter, setAmountPerQuarter] = useState({
  //   first_qtr_amount: 0,
  //   second_qtr_amount: 0,
  //   third_qtr_amount: 0,
  //   fourth_qtr_amount: 0,
  // })

  // const [formTotal] = useState(() => {
  //   // use for EDIT modal: get initial_fees grand total from dataInfo and compare it to formData.initial_fees grand total, if !==, update quarters.
  //   if(type === "EDIT") {
  //     return _.sum(_.get(dataInfo, "initial_fees")?.map(item => item.total) || 0)
  //   }

  //   return 0
  // })

  // for EDIT: check if total amount has been changed based on total initial_fees
  const [isTotalAmountAdjusted, setIsTotalAmountAdjusted] = useState(false)

  const previousTotalValue = usePreviousValue(_.sum(_.get(dataInfo, "initial_fees")?.map(item => item.total) || 0))

  const [tab, setTab] = useState(0)
  const setModal = useContext(ModalContext);

  // const isStatusPaid = _.get(dataInfo, "status")?.toUpperCase()?.includes("PAID") || false
  const isStatusPaid = _.get(dataInfo, "status")?.toUpperCase() === "PAID" || false
  const isFirstQuarterPaid = _.get(dataInfo, "status")?.toUpperCase()?.includes("1ST QUARTER")
  const isSecondQuarterPaid = _.get(dataInfo, "status")?.toUpperCase()?.includes("2ND QUARTER")
  const isThirdQuarterPaid = _.get(dataInfo, "status")?.toUpperCase()?.includes("3RD QUARTER")

  const [pinFormat, setPinFormat] = useState(false);

  const getCurrentYear = () => `${new Date().getFullYear()}`;

  // const getYearsList = (start = getCurrentYear(), endOffset = 50) => {
  //   let y = [];
  //   for (let i = start; i > start - endOffset; i -= 1) {
  //     y = y.concat([
  //       {
  //         label: `${i}`,
  //         value: i,
  //       },
  //     ]);
  //   }
  //   return y;
  // };

  let commonValidation = {
    // tdn: `required|mask:${_.get(CMS_MASKINGS, 'RPTAX_TDN_REGEX_CSV')}~${_.get(
    //   CMS_MASKINGS,
    //   'RPTAX_TDN_CSV'
    // )}`,
    // pin: `required|mask:${_.get(CMS_MASKINGS, 'RPTAX_PIN_REGEX_CSV')}~${_.get(
    //   CMS_MASKINGS,
    //   'RPTAX_PIN_CSV'
    // )}`,
    // year: 'required',
    // account_number: `required|mask:${_.get(
    //   CMS_MASKINGS,
    //   'RPTAX_TDN_REGEX_CSV'
    // )}~${_.get(CMS_MASKINGS, 'RPTAX_TDN_CSV')}`,
    // account_name: 'required',
    // date_processed: 'required',
    // expiration_date: 'required',
    // amount: 'required|amount',

    // new details
    bin: 'required',
    tdp_no: 'required',
    assessment_date: 'required',
    expiration_date: 'required',
    account_name: 'required',
    account_no: 'required',
    business_name: 'required',
    type: 'required',
    owners_name: 'required',
    street: 'required',
    barangay_code: 'required',
    municipality_code: 'required',
    province_code: 'required',
    region_code: 'required',
    zip_code: 'required',
    tax_year: 'required',
    contact_no: 'required',
    
    // initial_activities: [{
    //   line_of_business: '',
    //   capital_amount: '',
    //   non_essential_gross_amount: '',
    //   essential_gross_amount: '',
    // }],
    // initial_fees: [{
    //   particulars: '',
    //   tax_due: '',
    //   interest: '',
    //   surcharge: '',
    //   total: '',
    // }],
    first_qtr_amount: 'required',
    second_qtr_amount: 'required',
    third_qtr_amount: 'required',
    fourth_qtr_amount: 'required',
  };

  if (!_.get(CMS_COMPONENTS, 'RPTAX_TDN_INPUT_FREE_TEXT')) {
    commonValidation = {
      ...commonValidation,
      tdn: 'required|rptax_tdn',
      account_number: 'required|rptax_tdn',
    };
  }

  const validateForm = useFormValidator(formData, commonValidation);
  const initialActivityValidateForm = useFormValidator(initialActivityFormData, {
    line_of_business: 'required',
    capital_amount: 'required',
    non_essential_gross_amount: 'required',
    essential_gross_amount: 'required',
  })


  const onChange = e => {
    return setFormData({
      ...formData,
      [e.target.name]:
        e.target.type === 'checkbox' ? e.target.checked : e.target.value,
    });
  };

  const onChangeBusinessAddress = (e) => {
    setFormData(prevForm => ({
      ...prevForm,
      region_code: _.get(e, "target.value.region_code"),
      province_code: _.get(e, "target.value.province_code"),
      municipality_code: _.get(e, "target.value.municipality_code"),
      barangay_code: _.get(e, "target.value.barangay_code"),
      street: _.get(e, "target.value.street"),
      zip_code: _.get(e, "target.value.zip_code"),
    }));
  };

    // temporary disable since 19 digit pin is disabled
  // useEffect(() => {
  //   if (pinFormat === false) {
  //     commonValidation = {
  //       ...commonValidation,
  //       account_number: `required|mask:${_.get(
  //         CMS_MASKINGS,
  //         'RPTAX_TDN_REGEX_CSV'
  //       )}~${_.get(CMS_MASKINGS, 'RPTAX_TDN_CSV')}`,
  //       tdn: `required|mask:${_.get(
  //         CMS_MASKINGS,
  //         'RPTAX_TDN_REGEX_CSV'
  //       )}~${_.get(CMS_MASKINGS, 'RPTAX_TDN_CSV')}`,
  //       pin: `required|mask:${_.get(
  //         CMS_MASKINGS,
  //         'RPTAX_PIN_REGEX_CSV'
  //       )}~${_.get(CMS_MASKINGS, 'RPTAX_PIN_CSV')}`,
  //     };
  //     validateForm.onSetObjectRules(commonValidation);
  //   }
  //   if (pinFormat) {
  //     commonValidation = {
  //       ...commonValidation,
  //       account_number: `required|mask:${_.get(
  //         CMS_MASKINGS,
  //         'RPTAX_TDN_REGEX_CSV'
  //       )}~${_.get(CMS_MASKINGS, 'RPTAX_TDN_CSV')}`,
  //       tdn: `required|mask:${_.get(
  //         CMS_MASKINGS,
  //         'RPTAX_TDN_REGEX_CSV'
  //       )}~${_.get(CMS_MASKINGS, 'RPTAX_TDN_CSV')}`,
  //       pin: `required|mask:${_.get(
  //         CMS_MASKINGS,
  //         'RPTAX_PIN_REGEX_2_CSV'
  //       )}~${_.get(CMS_MASKINGS, 'RPTAX_PIN_2_CSV')}`,
  //       // pin: `required|mask:${_.get(CMS_MASKINGS, 'RPTAX_PIN_REGEX_2')}~${_.get(CMS_MASKINGS, 'RPTAX_PIN_CSV')}`
  //     };
  //     validateForm.onSetObjectRules(commonValidation);
  //   }
  // }, [pinFormat]);

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  const handlePinFormat = e => {
    if (e.target.checked) {
      setPinFormat(true);
    } else {
      setPinFormat(false);
    }
  };

  const handleOnChange = key => e => {
    setFormData({
      ...formData,
      [key]: e.target.value,
    });

    // Note: this condition has been moved to SOA Amount input field as per <NumberFormat /> requirements
    // const isDecimal =
    //   e.target.value && /^\d{1,}(\.\d{0,4})?$/.test(e.target.value);

    // if (isDecimal && key === 'amount') {
    //   setFormData({
    //     ...formData,
    //     amount: e.target.value,
    //     first_quarter: (parseFloat(e.target.value) * parseFloat(.25)),
    //     second_quarter: (parseFloat(e.target.value) * parseFloat(.50)),
    //     third_quarter: (parseFloat(e.target.value) * parseFloat(.75)),
    //     fourth_quarter: e.target.value,
    //   });
    // }
  };

  const handleOnChangeDate = key => ({ target: { value } }) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  const handleOnSubmit = e => {
    e.preventDefault();

    const args = {
      ...formData,
      // period_covered_from: `${moment(_.get(formData, 'period_covered_from')).format(
      //   'YYYY-MM-DD'
      // )}`,
      // date_processed: `${moment(_.get(formData, 'date_processed')).format(
      //   'YYYY-MM-DD'
      // )}`,
      assessment_date: `${moment(_.get(formData, 'assessment_date')).format(
        'YYYY-MM-DD'
      )}`,
      expiration_date: `${moment(_.get(formData, 'expiration_date')).format(
        'YYYY-MM-DD'
      )}`,
      // amount: parseInt(_.get(formData, 'amount')?.replace(/,/g, ''), {}),
    };

    if (!validateForm.response.is_passed) {
      if(tab === 0) {
          setTab(+tab+1)
      }
      if(tab === 1) {
          setTab(+tab+1)
      }
      if(tab === 2) {
          setTab(+tab+1)
      }
      // if(tab === ) {
      //     setTab(+tab+1)
      // }
      return false;
    }

    // temporary add condition to only submit if in page 3 while other pages doesn't have data yet
    if (validateForm.response.is_passed) {
      if(tab === 0 && tab !== 2) {
          setTab(+tab+1)
      }
      if(tab === 1 && tab !== 2) {
          setTab(+tab+1)
      }
      if(tab === 2 && tab !== 3) {
          setTab(+tab+1)
      }
      if(tab === 3 ) {
        // submit
        if (type === 'ADD') {
          // createRecord(args, () => {
          createRecordManualImport(args, () => {
            setModal({ isOpen: false });
            getListManualImport({
              // overwrite_previous: 0,
              // is_active: 1,
            });
            history.push(`/billing/btax`);
          });
        }
    
        if (type === 'EDIT') {
          updateRecordManualImport(id, args, () => {
          // updateRecord(id, args, () => {
            setModal({ isOpen: false });
            getListManualImport({
              overwrite_previous: 0,
              is_active: 1,
            });
            history.push(`/billing/btax`);
          });
        }
      }
      return false;
    }

    return true
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const handleOnChangeSelect = key => e => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
    if (key === 'year') {
      setFormData({
        ...formData,
        [key]: e ? e.value : '',
        mode_of_payment_1: `${e.value}-1`,
        mode_of_payment_2: `${e.value}-4`,
      });
    }
  };

  const onChangeInitialBusinessActivities = e => {
    e.preventDefault()
    setInitialActivityFormData({
      ...initialActivityFormData,
      [e.target.name]: e.target.value?.toUpperCase(),
    });
  };

  const handleAddBusinessActivityField = e => {
    e.preventDefault()

    setFormData({
      ...formData,
      initial_activities: [..._.get(formData, "initial_activities"), initialActivityFormData],
    });

    setInitialActivityFormData({
      line_of_business: "",
      capital_amount: "",
      non_essential_gross_amount: "",
      essential_gross_amount: "",
    });

    setFocus(false)
  };


  const handleUpdateInitialBusinessActivityField = (data, id) => (e) => {
    e.preventDefault();
    // setToggleInitialActivityUpdate(prevState => !prevState)
    setToggleInitialActivityUpdate(true)
    setActivityUpdateInfo({ data, id})

    // setModal({
    //   isOpen: true,
    //   content: (
    //     <UpdateBusinessActivity
    //       itemId={id}
    //       data={data}
    //       formData={formData}
    //       setFormData={setFormData}
    //       handleOnChange={handleOnChange}
    //       initialActivityFormData={initialActivityFormData}
    //       initialActivityValidateForm={initialActivityValidateForm}
    //       setInitialActivityFormData={setInitialActivityFormData}
    //     />
    //   ),
    //   title: "Update Business Activity",
    //   modalSize: "modal-md",
    //   customModalId: 'test-modal'
    // });
  };

  const handleDeleteInitialBusinessActivityField = (id) => {
    const arr = _.filter(
      _.get(formData, "initial_activities"),
      (_item, index) => index !== id
    );

    ConfirmAlert(
      <div>
        <p className='mb-0'>Are you sure you want to delete this Activity?</p>
      </div>,
      () => {
        setFormData((prevForm) => ({
          ...prevForm,
          initial_activities: [...arr],
        }));
        setToggleInitialActivityUpdate(false)
      },
      () => {},
      { yesLabel: "Confirm", noLabel: "Cancel", }
    );
  };

  const handleOnFocus = () => {
    if(
      _.isEmpty(_.get(initialActivityFormData, "line_of_business")) &&
      _.isEmpty(_.get(initialActivityFormData, "capital_amount")) &&
      _.isEmpty(_.get(initialActivityFormData, "non_essential_gross_amount")) &&
      _.isEmpty(_.get(initialActivityFormData, "essential_gross_amount"))
    ) {
      setFocus(true)
    }
  }

  const handleOnBlur = () => {
    if(
      _.isEmpty(_.get(initialActivityFormData, "line_of_business")) &&
      _.isEmpty(_.get(initialActivityFormData, "capital_amount")) &&
      _.isEmpty(_.get(initialActivityFormData, "non_essential_gross_amount")) &&
      _.isEmpty(_.get(initialActivityFormData, "essential_gross_amount"))
    ) {
      setFocus(false)
    }
    if(
        !_.isEmpty(_.get(initialActivityFormData, "line_of_business")) ||
       !_.isEmpty(_.get(initialActivityFormData, "capital_amount")) ||
       !_.isEmpty(_.get(initialActivityFormData, "non_essential_gross_amount")) ||
       !_.isEmpty(_.get(initialActivityFormData, "essential_gross_amount"))
     ) {
      setFocus(true)
     }
  }
  
  const totalDueAndPayable = parseFloat(_.sum(_.get(formData, "initial_fees").map(item => item.total) || 0).toFixed(2))

  useEffect(() => {
    // todo: simplify the codes inside this useEffect later..
    if(type !== "EDIT") {
      setFormData({
        ...formData,
        first_qtr_amount: totalDueAndPayable / 4,
        second_qtr_amount: totalDueAndPayable / 4,
        third_qtr_amount: totalDueAndPayable / 4,
        fourth_qtr_amount: totalDueAndPayable / 4,
      })
    }
  }, [totalDueAndPayable, dataInfo])

  useEffect(() => {
    // set quarter values if total amount has been changed or total value is not equal to initial value in EDIT modal
    if(type === "EDIT" && previousTotalValue !== totalDueAndPayable) {
      setFormData({
        ...formData,
        first_qtr_amount: totalDueAndPayable / 4,
        second_qtr_amount: totalDueAndPayable / 4,
        third_qtr_amount: totalDueAndPayable / 4,
        fourth_qtr_amount: totalDueAndPayable / 4,
      })
    }
// set quarter values if total amount has been reverted to initial value in edit modal, 
    if(type === "EDIT" && (isTotalAmountAdjusted && previousTotalValue === totalDueAndPayable)) {
      setFormData({
        ...formData,
        first_qtr_amount: totalDueAndPayable / 4,
        second_qtr_amount: totalDueAndPayable / 4,  
        third_qtr_amount: totalDueAndPayable / 4,
        fourth_qtr_amount: totalDueAndPayable / 4,
      })

    }
  }, [totalDueAndPayable, dataInfo])


  // error validation
  const totalDueQuarterlyValidation = () => {
    const quarterItems = [_.get(formData, "first_qtr_amount"), _.get(formData, "second_qtr_amount"), _.get(formData, "third_qtr_amount"), _.get(formData, "fourth_qtr_amount")]
    const totalQuarters = _.sum(quarterItems)
    if(!_.get(formData, "first_qtr_amount")) return true
    // returns true if sum of all quarter is > or < the total due payables
    if (Math.round(parseFloat(totalQuarters) - 1) > totalDueAndPayable || Math.round(parseFloat(totalQuarters) + 1) < totalDueAndPayable) return true
    // returns true if any quarter has negative value (except -0), else return false
    if(quarterItems.some(item => Math.sign(item) === -1)) return true
    return false
  }

  useEffect(() => {
    if (type === 'EDIT') {
      const splitStr = dataInfo.pin?.replace(/\s+/g, '-').length;
      if (splitStr > 19) {
        setPinFormat(true);
      } else {
        setPinFormat(false);
      }

      setFormData({
        // tdn: dataInfo.tdn,
        // pin: dataInfo.pin,
        // year: dataInfo.year,
        // account_number: dataInfo.account_number,
        // account_name: dataInfo.account_name,
        // date_processed: moment(dataInfo.date_processed).format('MM-DD-YYYY'),
        // expiration_date: moment(dataInfo.expiration_date).format('MM-DD-YYYY'),
        // first_quarter:
        //   parseFloat(parseFloat(dataInfo.amount?.replace(/,/g, ''))) *
        //   parseFloat(0.25),
        // second_quarter:
        //   parseFloat(parseFloat(dataInfo.amount?.replace(/,/g, ''))) *
        //   parseFloat(0.5),
        // third_quarter:
        //   parseFloat(parseFloat(dataInfo.amount?.replace(/,/g, ''))) *
        //   parseFloat(0.75),
        // fourth_quarter: parseFloat(dataInfo.amount?.replace(/,/g, '')),
        // is_delinquent: dataInfo.is_delinquent,
        // is_overwrite: dataInfo.is_overwrite,
        // amount: parseFloat(dataInfo.amount?.replace(/,/g, '')),
        // mode_of_payment_1: dataInfo.mode_of_payment_1,
        // mode_of_payment_2: dataInfo.mode_of_payment_2,
        bin: dataInfo.bin,
        tdp_no: dataInfo.tdp_no,
        // assessment_date: dataInfo.assessment_date,
        assessment_date: `${moment(_.get(dataInfo, 'assessment_date')).format('MM-DD-YYYY')}`,
        // // expiration_date: dataInfo.expiration_date,
        expiration_date: `${moment(_.get(dataInfo, 'expiration_date')).format('MM-DD-YYYY')}`,
        account_name: dataInfo.account_name,
        account_no: dataInfo.account_no,
        business_name: dataInfo.business_name,
        type: dataInfo.type,
        owners_name: dataInfo.owners_name,
        street: dataInfo.street,
        barangay_code: dataInfo.barangay_code,
        municipality_code: dataInfo.municipality_code,
        province_code: dataInfo.province_code,
        region_code: dataInfo.region_code,
        zip_code: dataInfo.zip_code,
        tax_year: dataInfo.tax_year,
        contact_no: dataInfo.contact_no,
        initial_activities: !_.isEmpty(dataInfo?.initial_activities) ? dataInfo?.initial_activities.map(item => ({
          line_of_business: item.line_of_business,
          capital_amount: item.capital_amount,
          non_essential_gross_amount: item.non_essential_gross_amount,
          essential_gross_amount: item.essential_gross_amount,
        })) : [],
        initial_fees: !_.isEmpty(dataInfo?.initial_fees) ? dataInfo?.initial_fees.map(item => ({
          particulars: item.particulars,
          tax_due: item.tax_due,
          interest: item.interest,
          surcharge: item.surcharge,
          total: item.total,
        })) : [
          { particulars: 'Garbage Fee', tax_due: 0, interest: 0, surcharge: 0, total: 0},
          { particulars: 'Sanitary Fee', tax_due: 0, interest: 0, surcharge: 0, total: 0},
          { particulars: 'Health Certification - Fee', tax_due: 0, interest: 0, surcharge: 0, total: 0},
          { particulars: 'Annual Tax Fee', tax_due: 0, interest: 0, surcharge: 0, total: 0},
          { particulars: 'Laboratory Fee', tax_due: 0, interest: 0, surcharge: 0, total: 0},
          { particulars: 'Occupational', tax_due: 0, interest: 0, surcharge: 0, total: 0},
          { particulars: 'Application Fee', tax_due: 0, interest: 0, surcharge: 0, total: 0},
          { particulars: 'Cetification Fee', tax_due: 0, interest: 0, surcharge: 0, total: 0},
          { particulars: 'Sticker Fee', tax_due: 0, interest: 0, surcharge: 0, total: 0},
          { particulars: 'Signbard (Orinary)', tax_due: 0, interest: 0, surcharge: 0, total: 0},
          { particulars: "Mayor's permit", tax_due: 0, interest: 0, surcharge: 0, total: 0},
          { particulars: "Fire Inspection Feee", tax_due: 0, interest: 0, surcharge: 0, total: 0},
          { particulars: "Annual Building Inspection Fee", tax_due: 0, interest: 0, surcharge: 0, total: 0},
        ],
        first_qtr_amount: dataInfo.first_qtr_amount,
        second_qtr_amount: dataInfo.second_qtr_amount,
        third_qtr_amount: dataInfo.third_qtr_amount,
        fourth_qtr_amount: dataInfo.fourth_qtr_amount,
      });
    }
  }, [dataInfo]);

  const MAX_VAL = 9999999999999999.99;
  const withValueCap = inputObj => {
    const { value } = inputObj;
    if (value <= MAX_VAL) return true;
    return false;
  };


// stepper:
const paginateButton = () => {
  return (
    <div className="py-1"> 
      {tab !== 3 && (
        <div className="col-12 d-flex justify-content-center mt-3">
          {tab !== 0 && (
            <button
              type="button"
              onClick={() => setTab(+tab - 1 < 0 ? 0 : +tab - 1)}
              className="btn btn-light button-cancel-2 mr-1"
              // teporary style
              style={{ backgroundColor: '#323943', color: '#fff' }}
            >
              Previous
            </button>
          )}
          {tab === 0 && (
            <button
              type="button"
              onClick={closeModal}
              className="btn btn-light button-cancel-2 mr-1"
              // teporary style
              style={{ backgroundColor: '#323943', color: '#fff' }}
            >
              Cancel
            </button>
          )}
          <button
            type="submit"
            className="btn btn-light button-proceed ml-1 cms-bg-color-primary text-light"
            // disabled={
            //   (tab === 0 && !validateForm.response.is_passed) ||
            //   (tab === 1 && !validateForm.response.is_passed) ||
            //   (tab === 2 && !validateForm.response.is_passed)
            // }
          >
            {/* <i className="fas fa-spinner fa-spin fa-lg" /> */}
            Next
          </button>
        </div>
      )}
      {tab === 3 && (
        <div className="col-12 d-flex justify-content-center mt-3">
          <button
            type="button"
            onClick={() => setTab(+tab - 1 < 0 ? 0 : +tab - 1)}
            className="btn btn-link button-cancel-2 mr-1"
            style={{ backgroundColor: '#323943', color: '#fff' }}
          >
            Previous
          </button>
          <button
            disabled={tab === 3 && (totalDueQuarterlyValidation() || !validateForm.response.is_passed)}
            type="submit"
            className={`btn btn-light button-proceed ml-1 cms-bg-color-primary ${isStatusPaid && "d-none"}`}
            style={{ color: '#fff' }}
          >
            {creating ? <i className="fas fa-spinner fa-spin fa-lg" /> : `Save`}
          </button>
        </div>
      )}
    </div>
  );
};

const renderInputMaskConfigFromCMS = (isDefault, mask) => {
  if(isDefault) return {}

  return {
    isInputMask: true,
    maskChar: '',
    mask,
  }
}


  return (
    <Modal.Body className="p-2">
      <form onSubmit={handleOnSubmit}>
        <div className="px-2">

          {/* 
            1st Page
            note: Move each page to a separate component
          */}
          {
            tab === 0 && (
              <>
                <div className="full-group-v2">
                  <div className="form-row">
                    <InputTemplate
                      // isInputMask
                      title="Business Identification Number (BIN)"
                      htmlFor="tdn"
                      containerClassName="col-sm-12 col-md-6 col-lg-4"
                      formValidatorMsg={validateForm.renderMessage("bin")}
                      // Input component props
                      placeholder=""
                      className="full-input-v2 text-uppercase"
                      disabled={isStatusPaid || isFirstQuarterPaid || isSecondQuarterPaid || isThirdQuarterPaid}
                      id="bin"
                      name="bin"
                      type="text"
                      // maskChar=""
                      // mask={_.get(CMS_MASKINGS, 'RPTAX_TDN_CSV')}
                      // mask="999-999-999"
                      autoComplete="none"
                      onChange={onChange}
                      value={_.get(formData, 'bin')?.toUpperCase() || ''}
                    />
                    <InputTemplate
                      // {...renderInputMaskConfigFromCMS(!_.get(CMS_COMPONENTS, 'RPTAX_TDN_INPUT_FREE_TEXT'), _.get(CMS_MASKINGS, 'RPTAX_TDN_CSV'))}
                      title="TDP Number"
                      htmlFor="tdp_no"
                      containerClassName="col-sm-12 col-md-6 col-lg-4"
                      formValidatorMsg={validateForm.renderMessage("tdp_no")}
                      // Input component props
                      // placeholder={pinFormat ? _.get(CMS_MASKINGS, 'RPTAX_PIN_2_CSV') : _.get(CMS_MASKINGS, 'RPTAX_PIN_CSV')}
                      placeholder=""
                      className="full-input-v2 text-uppercase"
                      disabled={isStatusPaid || isFirstQuarterPaid || isSecondQuarterPaid || isThirdQuarterPaid}
                      id="tdp_no"
                      name="tdp_no"
                      type="text"
                      // mask={pinFormat ? _.get(CMS_MASKINGS, 'RPTAX_PIN_2_CSV') : _.get(CMS_MASKINGS, 'RPTAX_PIN_CSV')}
                      autoComplete="none"
                      onChange={onChange}
                      value={_.get(formData, 'tdp_no')?.toUpperCase() || ''}
                    />
                    <InputTemplate
                      title="Account Number"
                      htmlFor="account_no"
                      containerClassName="col-sm-12 col-md-6 col-lg-4"
                      formValidatorMsg={validateForm.renderMessage("account_no")}
                      // Input component props
                      placeholder="Account No."
                      className="full-input-v2 text-uppercase"
                      disabled={isStatusPaid || isFirstQuarterPaid || isSecondQuarterPaid || isThirdQuarterPaid}
                      id="account_no"
                      name="account_no"
                      type="text"
                      autoComplete="none"
                      onChange={onChange}
                      value={_.get(formData, 'account_no')?.toUpperCase() || ''}
                    />
                    <InputTemplate
                      title="Account Name"
                      htmlFor="account_name"
                      containerClassName="col-sm-12 col-md-6 col-lg-4"
                      formValidatorMsg={validateForm.renderMessage("account_name")}
                      // Input component props
                      placeholder="Account Name"
                      className="full-input-v2 text-uppercase"
                      disabled={isStatusPaid || isFirstQuarterPaid || isSecondQuarterPaid || isThirdQuarterPaid}
                      id="account_name"
                      name="account_name"
                      type="text"
                      autoComplete="none"
                      onChange={onChange}
                      value={_.get(formData, 'account_name')?.toUpperCase() || ''}
                    />
                    <InputTemplate
                      title="Business Name"
                      htmlFor="business_name"
                      containerClassName="col-sm-12 col-md-6 col-lg-4"
                      formValidatorMsg={validateForm.renderMessage("business_name")}
                      // Input component props
                      placeholder="Business Name"
                      disabled={isStatusPaid || isFirstQuarterPaid || isSecondQuarterPaid || isThirdQuarterPaid}
                      className="full-input-v2 text-uppercase"
                      id="business_name"
                      name="business_name"
                      type="text"
                      autoComplete="none"
                      onChange={onChange}
                      value={_.get(formData, 'business_name')?.toUpperCase() || ''}
                    />
                    <InputTemplate
                      title="Owner's Full Name"
                      htmlFor="owners_name"
                      containerClassName="col-sm-12 col-md-6 col-lg-4"
                      formValidatorMsg={validateForm.renderMessage("owners_name")}
                      // Input component props
                      placeholder="Owner's Full Name"
                      className="full-input-v2 text-uppercase"
                      disabled={isStatusPaid || isFirstQuarterPaid || isSecondQuarterPaid || isThirdQuarterPaid}
                      id="owners_name"
                      name="owners_name"
                      type="text"
                      autoComplete="none"
                      onChange={onChange}
                      value={_.get(formData, 'owners_name')?.toUpperCase() || ''}
                    />
                    <InputTemplate
                      title="Date Assessed"
                      htmlFor="assessment_date"
                      containerClassName="col-sm-12 col-md-6 col-lg-4"
                      formValidatorMsg={validateForm.renderMessage("assessment_date")}
                      withCustomInputComponent={() => (
                        <DateInputPicker
                          inputClassName="full-input form-input-record-v2"
                          placeholder="MM/DD/YYYY"
                          disabled={isStatusPaid || isFirstQuarterPaid || isSecondQuarterPaid || isThirdQuarterPaid}
                          btnClassName="button-date2-v2 cms-bg-color-secondary cms-outline-secondary"
                          onChange={handleOnChangeDate('assessment_date')}
                          value={_.get(formData, 'assessment_date') || ''}
                        />
                      )}
                    />
                    <InputTemplate
                      title="Expiration Date"
                      htmlFor="expiration_date"
                      containerClassName="col-sm-12 col-md-6 col-lg-4"
                      formValidatorMsg={validateForm.renderMessage("expiration_date")}
                      withCustomInputComponent={() => (
                        <DateInputPicker
                          inputClassName="full-input form-input-record-v2"
                          placeholder="MM/DD/YYYY"
                          disabled={isStatusPaid || isFirstQuarterPaid || isSecondQuarterPaid || isThirdQuarterPaid}
                          btnClassName="button-date2-v2 cms-bg-color-secondary cms-outline-secondary"
                          onChange={handleOnChangeDate('expiration_date')}
                          value={_.get(formData, 'expiration_date') || ''}
                        />
                      )}
                    />
                    <InputTemplate
                      isSelect
                      title="Transaction Type"
                      htmlFor="type"
                      containerClassName="col-sm-12 col-md-6 col-lg-4"
                      formValidatorMsg={validateForm.renderMessage("type")}
                      // Input component props
                      placeholder="Type"
                      styles={reactSelectCustomStyleCms()}
                      isDisabled={isStatusPaid || isFirstQuarterPaid || isSecondQuarterPaid || isThirdQuarterPaid}
                      // className="full-input text-uppercase"
                      className="full-input"
                      id="type"
                      name="type"
                      type="input"
                      options={c.TRANSACTION_TYPE}
                      onChange={handleOnChangeSelect('type')}
                      value={c.TRANSACTION_TYPE.find((item) => _.get(formData, "type") === _.get(item, "value")) || ""}
                      components={{ IndicatorSeparator: () => null }}
                    />
                  </div>
                </div>
                <div className="full-group-v2">
                 <h3 className="font-weight-bolder mb-2 mt-4 cms-text-primary">Address</h3>
                  <div className="form-row">                    
                    <AddressGroupComponent
                      isDisabled={isStatusPaid || isFirstQuarterPaid || isSecondQuarterPaid || isThirdQuarterPaid}
                      name="Address"
                      region_name="region_code"
                      province_name="province_code"
                      municipality_name="municipality_code"
                      barangay_name="barangay_code"
                      street_name="street"
                      zip_code_name="zip_code"
                      onChange={onChangeBusinessAddress}
                      value={{
                        region_code: _.get(formData, "region_code") || "",
                        // region_code: "080000000" || "",
                        province_code: _.get(formData, "province_code") || "" ,
                        municipality_code: _.get(formData, "municipality_code") || "" ,
                        barangay_code: _.get(formData, "barangay_code") || "",
                        street: _.get(formData, "street") || "",
                        zip_code: _.get(formData, "zip_code") || "",
                      }}
                      validatorMessage={validateForm.renderMessage}
                    />
                  </div>
                </div>
              </>
            )
          }
          {/* 2nd Page */}
          {
            tab === 1 && (
              <>
                <div className="full-group-v2">
                  <h3 className="font-weight-bolder mb-2 mt-4 cms-text-primary">Business Activity</h3>
                  <div className="form-row mb-2">
                    <InputTemplate
                      title="Tax Year"
                      htmlFor="tax_year"
                      containerClassName="col-sm-12 col-md-6 col-lg-4"
                      formValidatorMsg={validateForm.renderMessage("tax_year")}
                      withCustomInputComponent={() => (
                        <DateInputPicker
                          showYearPicker
                          disabled={isStatusPaid || isFirstQuarterPaid || isSecondQuarterPaid || isThirdQuarterPaid}
                          inputClassName="full-input form-input-record-v2"
                          placeholder="YYYY"
                          btnClassName="button-date2-v2 cms-bg-color-secondary cms-outline-secondary"
                          onChange={handleOnChangeDate('tax_year')}
                          value={_.get(formData, 'tax_year')?.toString() || ''}
                        />
                      )}
                    />
                    <InputTemplate
                      isInputMask
                      title="Contact No."
                      htmlFor="contact_no"
                      containerClassName="col-sm-12 col-md-6 col-lg-4"
                      formValidatorMsg={validateForm.renderMessage("contact_no")}
                      // Input component props
                      placeholder=""
                      className="full-input-v2 text-uppercase"
                      disabled={isStatusPaid || isFirstQuarterPaid || isSecondQuarterPaid || isThirdQuarterPaid}
                      id="contact_no"
                      name="contact_no"
                      type="text"
                      maskChar=""
                      // mask={_.get(CMS_MASKINGS, 'RPTAX_TDN_CSV')}
                      autoComplete="none"
                      onChange={onChange}
                      value={_.get(formData, 'contact_no')?.toUpperCase() || ''}
                    />
                  </div>

                  <div className="border rounded" style={{ overflowX: 'scroll' }}>
                    <div className="container-fluid mx-auto px-0" style={{ minWidth: '720px' }}>
                      <div className="mb-2 justify-content-center activity-container-btax">
                        {/* <div className="d-none col-1 d-flex align-items-center justify-content-center p-2" /> */}
                        <div className="d-flex align-items-center justify-content-center cms-bg-color-primary-light border-bottom p-2">
                          <b className="text-center m-0 cms-text-primary ">Line of Business</b>
                        </div>
                        <div className="d-flex align-items-center justify-content-center cms-bg-color-primary-light border-bottom p-2">
                          <b className="text-center m-0 cms-text-primary">
                            Capital Investment
                          </b>
                        </div>
                        <div className="d-flex align-items-center justify-content-center cms-bg-color-primary-light border-bottom p-2">
                          <b className="text-center m-0 cms-text-primary">
                            Gross Receipt
                            <br />
                            (Non-Essential)
                          </b>
                        </div>
                        <div className="d-flex align-items-center justify-content-center cms-bg-color-primary-light border-bottom p-2">
                          <b className="text-center m-0 cms-text-primary">Gross Receipt (Essential)</b>
                        </div>
                        <div className="d-flex align-items-center justify-content-center cms-bg-color-primary-light border-bottom p-2" />
                      </div>
                    </div>
                    {/* inputs */}
                    <div className="activity-container-btax px-2 pt-2 pb-3 mt-1 align-items-end justify-content-center border-bottom" style={{ maxHeight: "400px", minWidth: '720px' }}>
                      <div className="">
                        <InputTemplate
                          containerClassName="mx-1"
                          formValidatorMsg={isFocus && initialActivityValidateForm.renderMessage("line_of_business")}
                          // Input component props
                          placeholder="_"
                          className="full-input-v2 text-uppercase"
                          disabled={isStatusPaid || isFirstQuarterPaid || isSecondQuarterPaid || isThirdQuarterPaid}
                          id="line_of_business"
                          name="line_of_business"
                          type="text"
                          onChange={onChangeInitialBusinessActivities}
                          onFocus={handleOnFocus}
                          onBlur={handleOnBlur}
                          value={_.get(initialActivityFormData, 'line_of_business')}
                        />
                      </div>
                      <div className="">
                        <InputTemplate
                          formValidatorMsg={isFocus && initialActivityValidateForm.renderMessage("capital_amount")}
                          containerClassName="mx-1"
                          labelClassName="py-0"
                          // Input component props
                          withCustomInputComponent={() => (
                            <NumberFormat
                              name="capital_amount"
                              id="capital_amount"
                              placeholder="0"
                              allowLeadingZeros={true}
                              className="full-input-v2"
                              onFocus={handleOnFocus}
                              onBlur={handleOnBlur}
                              disabled={isStatusPaid || isFirstQuarterPaid || isSecondQuarterPaid || isThirdQuarterPaid}
                              onValueChange={(values) => {
                                // const { formattedValue, value } = values;
                                const { floatValue } = values;
                                setInitialActivityFormData({
                                  ...initialActivityFormData,
                                  capital_amount: floatValue,
                                })
                              }}
                              displayType="input"
                              isNumericString={true}
                              thousandSeparator={true}
                              prefix="" 
                              value={_.get(initialActivityFormData, 'capital_amount')?.toString() || ''}
                            />
                          )}
                        />
                      </div>
                      <div className="">
                        <InputTemplate
                          formValidatorMsg={isFocus && initialActivityValidateForm.renderMessage("non_essential_gross_amount")}
                          containerClassName="mx-1"
                          labelClassName="py-0"
                          // Input component props
                          withCustomInputComponent={() => (
                            <NumberFormat
                              name="non_essential_gross_amount"
                              id="non_essential_gross_amount"
                              placeholder="0"
                              allowLeadingZeros={true}
                              className="full-input-v2"
                              onFocus={handleOnFocus}
                              onBlur={handleOnBlur}
                              disabled={isStatusPaid || isFirstQuarterPaid || isSecondQuarterPaid || isThirdQuarterPaid}
                              onValueChange={(values) => {
                                // const { formattedValue, value } = values;
                                const { floatValue } = values;
                                setInitialActivityFormData({
                                  ...initialActivityFormData,
                                  non_essential_gross_amount: floatValue ,
                                })
                              }}
                              displayType="input"
                              isNumericString={true}
                              thousandSeparator={true}
                              prefix="" 
                              value={_.get(initialActivityFormData, 'non_essential_gross_amount')?.toString() || ''}
                            />
                          )}
                        />
                      </div>
                      <div className="">
                        <InputTemplate
                          formValidatorMsg={isFocus && initialActivityValidateForm.renderMessage("essential_gross_amount")}
                          containerClassName="mx-1"
                          labelClassName="py-0"
                          // Input component props
                          withCustomInputComponent={() => (
                            <NumberFormat
                              name="essential_gross_amount"
                              id="essential_gross_amount"
                              placeholder="0"
                              allowLeadingZeros={true}
                              className="full-input-v2"
                              onFocus={handleOnFocus}
                              onBlur={handleOnBlur}
                              disabled={isStatusPaid || isFirstQuarterPaid || isSecondQuarterPaid || isThirdQuarterPaid}
                              onValueChange={(values) => {
                                // const { formattedValue, value } = values;
                                const { floatValue } = values;
                                setInitialActivityFormData({
                                  ...initialActivityFormData,
                                  essential_gross_amount: floatValue,
                                })
                              }}
                              displayType="input"
                              isNumericString={true}
                              thousandSeparator={true}
                              prefix="" 
                              value={_.get(initialActivityFormData, 'essential_gross_amount')?.toString() || ''}
                            />
                          )}
                        />
                      </div>
                      <div className="my-1 ml-2">
                        <button
                          type="button"
                          disabled={!initialActivityValidateForm.response.is_passed}
                          onClick={handleAddBusinessActivityField}
                          className="btn btn-primary cms-bg-color-primary cms-outline-primary mr-2"
                        >
                          <i className="fa fa-plus py-2 mr-2" /> Add Business Activity
                        </button>
                      </div>
                    </div>
                  
                  {/* initial_activity list display */}

                    {_.get(formData, "initial_activities")?.map((item, index) => {

                      return (
                        <>
                          <div
                            key={index}
                            className="activity-container-btax px-2 pt-2 pb-3 mt-1 justify-content-center border-bottom"
                            style={{ maxHeight: '400px', minWidth: '720px' }}
                          >
                            <div className="">
                              <InputTemplate
                                containerClassName="mx-1"
                                // formValidatorMsg={initialActivityValidateForm.renderMessage("line_of_business")}
                                // Input component props
                                placeholder="0"
                                readOnly
                                className="full-input-v2 text-uppercase"
                                id="line_of_business"
                                name="line_of_business"
                                type="text"
                                onChange={onChangeInitialBusinessActivities}
                                value={_.get(item, 'line_of_business')}
                              />
                            </div>
                            <div className="">
                              <InputTemplate
                                containerClassName="mx-1"
                                // formValidatorMsg={initialActivityValidateForm.renderMessage("capital_amount")}
                                // Input component props
                                placeholder="0"
                                readOnly
                                className="full-input-v2 text-uppercase"
                                id="capital_amount"
                                name="capital_amount"
                                type="text"
                                onChange={onChangeInitialBusinessActivities}
                                value={numberWithCommas(
                                  _.get(item, 'capital_amount')
                                )}
                              />
                            </div>
                            <div className="">
                              <InputTemplate
                                containerClassName="mx-1"
                                // formValidatorMsg={initialActivityValidateForm.renderMessage("non_essential_gross_amount")}
                                // Input component props
                                placeholder="0"
                                readOnly
                                className="full-input-v2 text-uppercase"
                                id="non_essential_gross_amount"
                                name="non_essential_gross_amount"
                                type="text"
                                onChange={onChangeInitialBusinessActivities}
                                value={numberWithCommas(
                                  _.get(item, 'non_essential_gross_amount')
                                )}
                              />
                            </div>
                            <div className="">
                              <InputTemplate
                                containerClassName="mx-1"
                                // formValidatorMsg={initialActivityValidateForm.renderMessage("essential_gross_amount")}
                                // Input component props
                                placeholder="0"
                                readOnly
                                className="full-input-v2 text-uppercase"
                                id="essential_gross_amount"
                                name="essential_gross_amount"
                                type="text"
                                onChange={onChangeInitialBusinessActivities}
                                value={numberWithCommas(
                                  _.get(item, 'essential_gross_amount')
                                )}
                              />
                            </div>
                            <div className="d-flex justify-content-center  align-items-center">
                              <button
                                type="button"
                                className={`btn no-btn no-border p-0 mx-1 ${(isStatusPaid || isFirstQuarterPaid || isSecondQuarterPaid || isThirdQuarterPaid) && 'd-none'}`}
                                onClick={handleUpdateInitialBusinessActivityField(item,index)}
                              >
                                {toggleInitialActivityUpdate && activityUpdateInfo.id === index ? 
                                (<div className="dot-flashing" />) : 
                                (<img src={updateIcon} alt="update_button" />)}
                              </button>
                              <button
                                type="button"
                                className={`btn no-btn no-border p-0 mx-1 ${(isStatusPaid || isFirstQuarterPaid || isSecondQuarterPaid || isThirdQuarterPaid) && 'd-none'}`}
                                onClick={() =>handleDeleteInitialBusinessActivityField(index)}
                              >
                                <img src={deleteIcon} alt="delete_button" />
                              </button>
                            </div>
                          </div>
                          {/* update/edit */}
                          <div className="cms-bg-color-muted">
                            {toggleInitialActivityUpdate &&
                              activityUpdateInfo.id === index && (
                                <UpdateBusinessActivity
                                  itemId={activityUpdateInfo.id}
                                  data={activityUpdateInfo.data}
                                  formData={formData}
                                  setFormData={setFormData}
                                  handleOnChange={handleOnChange}
                                  initialActivityFormData={initialActivityFormData}
                                  initialActivityValidateForm={initialActivityValidateForm}
                                  setInitialActivityFormData={setInitialActivityFormData}
                                  toggleInitialActivityUpdate={toggleInitialActivityUpdate}
                                  setToggleInitialActivityUpdate={setToggleInitialActivityUpdate}
                                />
                              )}
                          </div>
                        </>
                      );
                    })}

                  </div>
                </div>
              </>
            )
          }
          {/* 3rd Page */}
          {
             tab === 2 && (
              <>
                <div className="full-group-v2">
                  <div className="table-scroll">
                    <table className="table table-sm table-hover">
                      <thead className="table-header">
                        <tr className="billing-table-tr px-2">
                          <th className="py-3 pl-2 cms-bg-color-primary align-middle text-light">
                            Particulars
                          </th>
                          <th className="py-3 cms-bg-color-primary align-middle text-light">
                            Tax Due
                          </th>
                          <th className="py-3 cms-bg-color-primary align-middle text-light">
                            Interest
                          </th>
                          <th className="py-3 cms-bg-color-primary align-middle text-light">
                            Surcharge
                          </th>
                          <th className="py-3 cms-bg-color-primary align-middle text-light">
                            Total
                          </th>
                        </tr>
                      </thead>
                      <tbody className="table-details">
                        {
                          _.get(formData, "initial_fees")?.map((data, i) => {
                            return (
                              <>
                                <tr key={i} className="billing-table-tr">
                                  <td className="py-3 pl-2 align-middle">
                                    <InputTemplate
                                      containerClassName="mx-1"
                                      // formValidatorMsg={initialActivityValidateForm.renderMessage("essential_gross_amount")}
                                      // Input component props
                                      placeholder="0"
                                      readOnly
                                      className="full-input-2 text-uppercase"
                                      id="particulars"
                                      name="particulars"
                                      type="text"
                                      onChange={() => {}}
                                      value={_.get(data, 'particulars')}
                                    />
                                  </td>
                                  <td className="py-3 pl-2 align-middle">
                                    <InputTemplate
                                      containerClassName="mx-1"
                                      // formValidatorMsg={validateForm.renderMessage("first_quarter")}
                                      withCustomInputComponent={() => (
                                        <NumberFormat
                                          name="tax_due"
                                          id="tax_due"
                                          placeholder="0"
                                          // className="full-input-v2 text-uppercase my-2"
                                          className="full-input-v2"
                                          style={{ width: '100px !important' }}
                                          onValueChange={values => {
                                            const { floatValue } = values
                                            setFormData({
                                              ...formData,
                                              // activities: [formData.activities[itemId] ? formUpdate : formData.activities]
                                              initial_fees: [
                                                ...formData.initial_fees.map((item, index) =>
                                                  index === i ? {...item, tax_due: floatValue} : item
                                                ),
                                              ],
                                            });

                                            // update value to true everytime there's a change in total amount
                                            setIsTotalAmountAdjusted(true)
                                          }}
                                          disabled={isStatusPaid || isFirstQuarterPaid || isSecondQuarterPaid || isThirdQuarterPaid}
                                          isAllowed={withValueCap}
                                          isNumericString
                                          thousandSeparator
                                          allowNegative
                                          allowLeadingZeros
                                          displayType="input"
                                          prefix=""
                                          value={_.get(data, 'tax_due')}
                                        />
                                      )} 
                                    />
                                  </td>
                                  <td className="py-3 align-middle">
                                    <InputTemplate
                                      containerClassName="mx-1"
                                      // formValidatorMsg={validateForm.renderMessage("first_quarter")}
                                      withCustomInputComponent={() => (
                                        <NumberFormat
                                          name="interest"
                                          id="interest"
                                          placeholder="0"
                                          // className="full-input-v2 text-uppercase my-2"
                                          className="full-input-v2"
                                          style={{ width: '100px !important' }}
                                          onValueChange={values => {
                                            const { floatValue } = values
                                            setFormData({
                                              ...formData,
                                              // activities: [formData.activities[itemId] ? formUpdate : formData.activities]
                                              initial_fees: [
                                                ...formData.initial_fees.map((item, index) =>
                                                  index === i ? {...item, interest: floatValue} : item
                                                ),
                                              ],
                                            });

                                            setIsTotalAmountAdjusted(true)
                                          }}
                                          disabled={isStatusPaid || isFirstQuarterPaid || isSecondQuarterPaid || isThirdQuarterPaid}
                                          isAllowed={withValueCap}
                                          isNumericString
                                          thousandSeparator
                                          allowNegative
                                          allowLeadingZeros
                                          displayType="input"
                                          prefix=""
                                          value={_.get(data, 'interest')}
                                        />
                                      )} 
                                    />
                                  </td>
                                  <td className="py-3 align-middle">
                                    <InputTemplate
                                      containerClassName="mx-1"
                                      // formValidatorMsg={validateForm.renderMessage("first_quarter")}
                                      withCustomInputComponent={() => (
                                        <NumberFormat
                                          name="Surcharge"
                                          id="surcharge"
                                          placeholder="0"
                                          // className="full-input-v2 text-uppercase my-2"
                                          className="full-input-v2"
                                          style={{ width: '100px !important' }}
                                          onValueChange={values => {
                                            const { floatValue } = values
                                            setFormData({
                                              ...formData,
                                              initial_fees: [
                                                ...formData.initial_fees.map((item, index) =>
                                                  index === i ? {...item, surcharge: floatValue} : item
                                                ),
                                              ],
                                            });

                                            setIsTotalAmountAdjusted(true)
                                          }}
                                          disabled={isStatusPaid || isFirstQuarterPaid || isSecondQuarterPaid || isThirdQuarterPaid}
                                          isAllowed={withValueCap}
                                          isNumericString
                                          thousandSeparator
                                          allowNegative
                                          allowLeadingZeros
                                          displayType="input"
                                          prefix=""
                                          value={_.get(data, 'surcharge')}
                                        />
                                      )} 
                                    />  
                                  </td>
                                  <td className="py-3 align-middle" style={{ width: "150px" }}>
                                    <InputTemplate
                                      containerClassName="mx-1"
                                      // formValidatorMsg={validateForm.renderMessage("first_quarter")}
                                      withCustomInputComponent={() => (
                                        <NumberFormat
                                          name="total"
                                          id="total"
                                          placeholder="0"
                                          // className="full-input-v2 text-uppercase my-2"
                                          className="full-input-2"
                                          style={{ width: '100px !important' }}
                                          onValueChange={values => {
                                            const { floatValue } = values
                                            setFormData({
                                              ...formData,
                                              // activities: [formData.activities[itemId] ? formUpdate : formData.activities]
                                              initial_fees: [
                                                ...formData.initial_fees.map((item, index) =>
                                                  index === i ? {...item, total: floatValue} : item
                                                ),
                                              ],
                                            });
                                          }}
                                          isAllowed={withValueCap}
                                          isNumericString
                                          thousandSeparator
                                          allowNegative
                                          allowLeadingZeros
                                          displayType="text"
                                          prefix=""
                                          // value={_.get(data, 'total', '') || ''}
                                          value={_.get(data, 'tax_due', 0) + _.get(data, 'interest', 0) + _.get(data, 'surcharge', 0)}
                                        />
                                      )} 
                                    />  
                                  </td>
                                </tr>
                              </>
                            )
                          })
                        }
                        {/* <tr className="billing-table-tr cms-bg-color-primary-light font-weight-bold">
                          <td className="py-3 align-middle cms-text-primary">GRAND TOTAL</td>
                          <td className="py-3 align-middle cms-text-primary">test</td>
                          <td className="py-3 align-middle cms-text-primary"><span className="border rounded d-flex p-1" style={{ width: '150px'}}>0.00</span></td>
                          <td className="py-3 align-middle cms-text-primary"><span className="border rounded d-flex p-1" style={{ width: '150px'}}>0.00</span></td>
                          <td className="py-3 align-middle cms-text-primary">2,710</td>
                        </tr> */}
                      </tbody>
                    </table>
                  </div>
                </div>
              </>
             )
          }
          {/* 4th Page */}
          {
             tab === 3 && (
              <>
                <div className="full-group-v2">
                <div className="alert cms-bg-color-primary-light py-3 my-3 d-flex align-items-center justify-content-between" style={{ minWidth: '720px'}}>
                  <h3 className="font-weight-bolder text-dark my-0">Total Due and Payable</h3>
                  <h3 className="font-weight-bolder text-dark my-0">{numberWithCommas(totalDueAndPayable)}</h3>
                </div>

                  <div className="table-scroll">
                    <table className="table table-sm table-hover">
                      <thead className="table-header">
                        <tr className="billing-table-tr px-2">
                          <th className="py-3 cms-bg-color-primary align-middle text-light">

                          </th>
                          <th className="py-3 cms-bg-color-primary align-middle text-light">
                            1st Quarter
                          </th>
                          <th className="py-3 cms-bg-color-primary align-middle text-light">
                            2nd Quarter
                          </th>
                          <th className="py-3 cms-bg-color-primary align-middle text-light">
                            3rd Quarter
                          </th>
                          <th className="py-3 cms-bg-color-primary align-middle text-light">
                            4th Quarter
                          </th>
                        </tr>
                      </thead>
                      <tbody className="table-details">
                        {/* temporary data for display only */}
                        <tr className="billing-table-tr">
                          <td className="py-3 pl-2 align-middle font-weight-bold">Amount Per Quarter{" "}
                          {totalDueQuarterlyValidation() && (<i className="text-danger" style={{ fontSize: '12px'}}>Total quarter amount should be Equal to <b>Total Dues & Payables</b>.</i>)}
                          </td>
                          <td className="py-3 align-middle">
                            <InputTemplate
                              containerClassName="mx-1"
                              // formValidatorMsg={validateForm.renderMessage("first_quarter")}
                              withCustomInputComponent={() => (
                                <NumberFormat
                                  name="first_qtr_amount"
                                  id="first_qtr_amount"
                                  placeholder="0"
                                  // className="full-input-v2 text-uppercase my-2"
                                  className="full-input-v2"
                                  style={{ width: '100px !important' }}
                                  onValueChange={values => {
                                    const { floatValue } = values
                                    // const value = floatValue === undefined ? 0 : floatValue
                                    const otherQuarterAdjustedValue = (totalDueAndPayable - (floatValue || 0)) / 3

                                    setFormData({
                                      ...formData,
                                      first_qtr_amount: floatValue || 0,
                                      second_qtr_amount: !floatValue ? 0 : otherQuarterAdjustedValue,
                                      third_qtr_amount: !floatValue ? 0 : otherQuarterAdjustedValue,
                                      fourth_qtr_amount: !floatValue ? 0 : otherQuarterAdjustedValue,
                                    });
                                  }}
                                  disabled={(isFirstQuarterPaid || isSecondQuarterPaid || isThirdQuarterPaid || isStatusPaid) || (dataInfo?.type === "NEW" || formData.type === "NEW")}
                                  isAllowed={withValueCap}
                                  decimalScale={2}
                                  isNumericString
                                  thousandSeparator
                                  allowNegative
                                  allowLeadingZeros
                                  displayType="input"
                                  prefix=""
                                  value={_.get(formData, 'first_qtr_amount', 0)}
                                />
                              )} 
                            />
                          </td>
                          <td className="py-3 align-middle">
                            <InputTemplate
                              containerClassName="mx-1"
                              // formValidatorMsg={validateForm.renderMessage("first_quarter")}
                              withCustomInputComponent={() => (
                                <NumberFormat
                                  name="second_qtr_amount"
                                  id="second_qtr_amount"
                                  placeholder="0"
                                  // className="full-input-v2 text-uppercase my-2"
                                  className="full-input-v2"
                                  style={{ width: '100px !important' }}
                                  onValueChange={values => {
                                    const { floatValue } = values
                                    const otherQuarterAdjustedValue = (totalDueAndPayable - (_.get(formData, 'first_qtr_amount', 0) + (floatValue || 0))) / 2

                                    setFormData({
                                      ...formData,
                                      second_qtr_amount: floatValue || 0,
                                      // first_qtr_amount: otherQuarterAdjustedValue,
                                      third_qtr_amount: otherQuarterAdjustedValue,
                                      fourth_qtr_amount: otherQuarterAdjustedValue,
                                    });
                                  }}
                                  disabled={!_.get(formData, 'first_qtr_amount') || (dataInfo?.type === "NEW" || formData.type === "NEW") || (isStatusPaid || isSecondQuarterPaid || isThirdQuarterPaid)}
                                  isAllowed={withValueCap}
                                  decimalScale={2}
                                  isNumericString
                                  thousandSeparator
                                  allowNegative
                                  allowLeadingZeros
                                  displayType="input"
                                  prefix=""
                                  value={_.get(formData, 'second_qtr_amount', 0)}
                                />
                              )} 
                            />
                          </td>
                          <td className="py-3 align-middle">
                            <InputTemplate
                              containerClassName="mx-1"
                              // formValidatorMsg={validateForm.renderMessage("first_quarter")}
                              withCustomInputComponent={() => (
                                <NumberFormat
                                  name="third_qtr_amount"
                                  id="third_qtr_amount"
                                  placeholder="0"
                                  // className="full-input-v2 text-uppercase my-2"
                                  className="full-input-v2"
                                  style={{ width: '100px !important' }}
                                  onValueChange={values => {
                                    const { floatValue } = values
                                    const otherQuarterAdjustedValue = (totalDueAndPayable - (_.get(formData, 'first_qtr_amount', 0) + _.get(formData, 'second_qtr_amount', 0) + (floatValue || 0)))

                                    setFormData({
                                      ...formData,
                                      third_qtr_amount: floatValue || 0,
                                      // first_qtr_amount: otherQuarterAdjustedValue,
                                      // second_qtr_amount: otherQuarterAdjustedValue,
                                      fourth_qtr_amount: otherQuarterAdjustedValue,
                                    });
                                  }}
                                  disabled={!_.get(formData, 'first_qtr_amount') || (dataInfo?.type === "NEW" || formData.type === "NEW") || isStatusPaid || isThirdQuarterPaid}
                                  isAllowed={withValueCap}
                                  decimalScale={2}
                                  isNumericString
                                  thousandSeparator
                                  allowNegative
                                  allowLeadingZeros
                                  displayType="input"
                                  prefix=""
                                  value={_.get(formData, 'third_qtr_amount', 0)}
                                />
                              )} 
                            />
                          </td>
                          <td className="py-3 align-middle">
                            <InputTemplate
                              containerClassName="mx-1"
                              // formValidatorMsg={validateForm.renderMessage("first_quarter")}
                              withCustomInputComponent={() => (
                                <NumberFormat
                                  name="fourth_qtr_amount"
                                  id="fourth_qtr_amount"
                                  placeholder="0"
                                  // className="full-input-v2 text-uppercase my-2"
                                  className="full-input-v2"
                                  style={{ width: '100px !important' }}
                                  onValueChange={values => {
                                    const { floatValue } = values
                                    // const otherQuarterAdjustedValue = (totalDueAndPayable - floatValue) / 3
                                    setFormData({
                                      ...formData,
                                      fourth_qtr_amount: floatValue || 0,
                                      // first_qtr_amount: otherQuarterAdjustedValue,
                                      // second_qtr_amount: otherQuarterAdjustedValue,
                                      // third_qtr_amount: otherQuarterAdjustedValue,
                                    });
                                  }}
                                  disabled={!_.get(formData, 'first_qtr_amount') || (dataInfo?.type === "NEW" || formData.type === "NEW") || isStatusPaid}
                                  isAllowed={withValueCap}
                                  decimalScale={2}
                                  isNumericString
                                  thousandSeparator
                                  allowNegative
                                  allowLeadingZeros
                                  displayType="input"
                                  prefix=""
                                  value={_.get(formData, 'fourth_qtr_amount', 0)}
                                />
                              )} 
                            />
                          </td>
                        </tr>
                        <tr className="billing-table-tr">
                          <td className="py-3 pl-2 align-middle">Pay on or before the due date, penalties are imposed after this period</td>
                          <td className="py-3 align-middle">28 Feb {currentYear}</td>
                          <td className="py-3 align-middle">20 Apr {currentYear}</td>
                          <td className="py-3 align-middle">20 Jul {currentYear}</td>
                          <td className="py-3 align-middle">20 Oct {currentYear}</td>
                        </tr>
                        <tr className="w-100" />
                      </tbody>
                    </table>
                    <div className="my-2 p-4 rounded cms-bg-color-primary-light w-100 text-left">
                      <b>REMINDERS</b>
                      <br />
                      <div className="pl-3" style={{ fontSize: '12px'}}>
                        <div className="py-1">&#8226; Please pay the amount due accordingly through online or at the Treasury Office.</div>
                        <div className="py-1">&#8226; Late payment will be subjected to 25% surcharge and monthly interest rate of 2% of the amount due to be paid at the same time and in the same manner as tax due.</div>
                        <div className="py-1">&#8226; For due date which falls on Saturdays, Sundays and Holidays shall be paid on the last working day prior to the due date.</div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
             )
          }
        </div>

        {paginateButton()}
      </form>
    </Modal.Body>
  );
}

AddRecordModalV2.defaultProps = {
  type: '',
  dataInfo: {},
  id: '',
};

AddRecordModalV2.propTypes = {
  // getList: PropTypes.instanceOf(Function).isRequired,
  getListManualImport: PropTypes.instanceOf(Function).isRequired,
  createRecordManualImport: PropTypes.instanceOf(Function).isRequired,
  updateRecordManualImport: PropTypes.instanceOf(Function).isRequired,
  // createRecord: PropTypes.instanceOf(Function).isRequired,
  // updateRecord: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  creating: PropTypes.bool.isRequired,
  type: PropTypes.string,
  id: PropTypes.string,
  dataInfo: PropTypes.instanceOf(Object),
  dataInclude: PropTypes.instanceOf(Object),
};

const mapStateToProps = ({ api }) => ({
  // creating: api.loading.indexOf(c.CREATE_RECORD) > -1,
  creating: api.loading.indexOf(c.CREATE_RECORD_MANUAL_IMPORT) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(AddRecordModalV2);
